// Deadline dates of an acceptance. The API sends Europe/Rome civil dates as 'YYYY-MM-DD'; they are
// formatted by splitting the string, never through Date, so the browser's time zone cannot shift
// them. Plain module with no Vue and no imports, so it runs under `node --test`.

// '2026-04-11' -> '11/04/2026'; anything else -> ''.
export function formatCivilDate(value) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || ""));
  return match ? `${match[3]}/${match[2]}/${match[1]}` : "";
}

// The formatted due date of one deadline of a dossier row or dossier, or '' when not set.
// kind is "depollution" or "deregistrationRequest".
export function dueDateText(source, kind) {
  const deadline = source && source.deadlines && source.deadlines[kind];
  return deadline ? formatCivilDate(deadline.dueDate) : "";
}
